import { Features } from '../../constants/features';
import { FeatureFlagDeclarations } from '../../feature-flags/feature-flag-declarations';
import { useFeatureFlag } from '../../feature-flags/hooks/use-feature-flag';
import { useIsSellerFeatureEnabled } from '../../hooks/use-is-seller-feature-enabled';

export const useIsHarmonizationSuggestionEnabled = () => {
  const isHsCodeSuggestionEnabledByFeatureFramework = useIsSellerFeatureEnabled(Features.AiHarmonizationCodeGenerator);
  const isHsCodeSuggestionEnabledByFeatureFlag = useFeatureFlag(FeatureFlagDeclarations.enableAiHarmonizationCodeGenerator);
  const isHarmonizationSuggestionEnabled = isHsCodeSuggestionEnabledByFeatureFramework && isHsCodeSuggestionEnabledByFeatureFlag;
  return isHarmonizationSuggestionEnabled;
};
